/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component } from 'react';
import { roleService } from '../../../ServiceFactory';
import { connect } from 'react-redux';
import { RoleKey, RoleManagementPermission } from '../../../shared/services/Role.service';
import { PlatformAdminUIState } from '../../../store/store';
import ActionMenuView from '../../../shared/views/ActionMenu/ActionMenu.view';
import { ActionMenuItemProps } from '../../../shared/views/ActionMenu/ActionMenu';
import DeleteGroupActionContainer from './actions/DeleteGroupAction.container';
import RenameGroupActionContainer from './actions/RenameGroupAction.container';
import ChangeGroupAdminsActionContainer from './actions/ChangeGroupAdminsAction.container';
import ChangeGroupGeoAreasActionContainer from './actions/ChangeGroupGeoAreasAction.container';
import ChangeGroupAccessibilityActionContainer from './actions/ChangeGroupAccessibilityAction.container';
interface Props {
	roleManagementPermission: RoleManagementPermission;
}

class GroupDetailsActionsMenuContainer extends Component<Props> {
	render(): JSX.Element | null {
		const { roleManagementPermission } = this.props;

		const validRoles: RoleKey[] = [RoleKey.GLOBAL_GROUP_ADMIN, RoleKey.USER_ADMIN, RoleKey.GLOBAL_USER_ADMIN];

		if (!roleService().hasClientRoleAssignmentSomeValidRole(roleManagementPermission.roles, validRoles)) {
			return null;
		}
		return (
			<ActionMenuView
				renderItems={(props: ActionMenuItemProps): JSX.Element[] => [
					<RenameGroupActionContainer key="renameGroup" {...props} />,
					<ChangeGroupAdminsActionContainer key="changeGroupAdmins" {...props} />,
					<ChangeGroupGeoAreasActionContainer key="changeGeoAreas" {...props} />,
					<ChangeGroupAccessibilityActionContainer key="changeAccessibility" {...props} />,
					<DeleteGroupActionContainer key="deleteGroup" {...props} />
				]}
			/>
		);
	}
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: PlatformAdminUIState) => {
	return {
		roleManagementPermission: state.global.roleManagementPermission
	};
};

export default connect(mapStateToProps)(GroupDetailsActionsMenuContainer);
